import { render, staticRenderFns } from "./MobileDriverConfigurations.vue?vue&type=template&id=096254f4&scoped=true"
import script from "./MobileDriverConfigurations.vue?vue&type=script&lang=js"
export * from "./MobileDriverConfigurations.vue?vue&type=script&lang=js"
import style0 from "./MobileDriverConfigurations.vue?vue&type=style&index=0&id=096254f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096254f4",
  null
  
)

export default component.exports